<ui-form-field-layout
	[isRequired]="isRequired()"
	[title]="title()"
	[subtitle]="subtitle()"
	[isValid]="isValid()"
	[hint]="hint()"
	[suffix]="suffix()"
>
	<div class="ui-input" slot="input">
		<div libFlexRow [libFlexRowGap]="'16px'">
			<div libFlexColumn libFlexFill>
				@if (calculatedMode() === 'dialog') {
				<div class="ui-input-with-icon">
					<input
						[ariaLabel]="title()"
						(click)="openSelectionDialog()"
						[ngClass]="inputDesignClass()"
						class="ui-input-selection"
						[class.card]="design() === 'card'"
						type="text"
						[placeholder]="placeholder()"
						[readOnly]="true"
						autocomplete="off"
						[ngModel]="displayValue()"
					/>

					@if (subtitleValue(); as subtitle) {
					<div class="ui-input-suffix">{{ subtitle }}</div>
					}

					<div class="ui-input-icon ui-input-cursor-pointer">
						<lib-icon [type]="'caretDown'"></lib-icon>
					</div>
				</div>

				} @else if (calculatedMode() === 'tooltipMenu') {

				<lib-tooltip-menu #selectionItemsMenu>
					@for (item of items(); track item.value; let first = $first; let last = $last) {
					<lib-tooltip-menu-item
						[isFirst]="first"
						[isLast]="last"
						[avatar]="item.avatar"
						(itemClick)="handleSelectItem(item)"
						[title]="item.title"
						[subtitle]="item.subtitle"
						[avatarLocation]="item.avatarLocation ?? 'start'"
					></lib-tooltip-menu-item>
					}
				</lib-tooltip-menu>

				<div
					class="ui-input-with-icon"
					[libTooltipMenu]="selectionItemsMenu"
					[libTooltipMenuPlacement]="'bottom-start'"
					[libTooltipMenuTrigger]="'click'"
				>
					<input
						[ariaLabel]="title()"
						[ngClass]="inputDesignClass()"
						class="ui-input-selection"
						[class.card]="design() === 'card'"
						type="text"
						[placeholder]="placeholder()"
						[readOnly]="true"
						autocomplete="off"
						[ngModel]="displayValue()"
					/>

					@if (subtitleValue(); as subtitle) {
					<div class="ui-input-suffix">{{ subtitle }}</div>
					}

					<div class="ui-input-icon ui-input-cursor-pointer">
						<lib-icon [type]="'caretDown'"></lib-icon>
					</div>
				</div>

				} @else if (calculatedMode() === 'chips') {

				<lib-chips-wrapper>
					@for (item of items(); track item.value) {
					<lib-chip
						[isActive]="isItemActive(item)"
						(click)="handleSelectItem(item)"
						[title]="item.title"
					></lib-chip>
					}
				</lib-chips-wrapper>

				} @else {
				<lib-message [type]="'warning'">Not supported mode {{ calculatedMode() }}</lib-message>
				}
			</div>

			@if (showClearButton()) {
			<div libFlexColumn>
				<lib-button [tooltip]="'Clear'" (click)="handleClear()" [iconOnly]="true" [icon]="'clear'"></lib-button>
			</div>

			}
		</div>
	</div>
</ui-form-field-layout>
